import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Booking from "@/components/Booking";
import CancelPage from "@/components/CancelPage";
import AdminPage from "@/components/AdminPage";
import Footer from "@/components/Footer";

export default function App() {
  const [search, setSearch] = useState(window.location.search);

  useEffect(() => {
    const onPop = () => setSearch(window.location.search);
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const navigate = (to) => {
    window.history.pushState({}, "", to);
    setSearch(to);
    window.scrollTo(0, 0);
  };

  const params = new URLSearchParams(search);
  const cancelToken = params.get("cancelar");
  const isAdmin = params.has("admin");
  const isBooking = params.has("agendar");
  const view = isAdmin ? "admin" : cancelToken ? "cancel" : isBooking ? "agenda" : "home";

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#0A0A0B] text-stone-200">
      <div
        className="pointer-events-none fixed inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.07),transparent_55%)]"
        aria-hidden="true"
      />
      <div
        className="pointer-events-none fixed inset-2 z-50 rounded-sm border border-amber-500/10 sm:inset-3"
        aria-hidden="true"
      />
      <div className="relative mx-auto min-h-screen w-full max-w-[430px] border-x border-amber-500/15 bg-[#0C0C0A] shadow-[0_0_90px_rgba(0,0,0,0.85)]">
        <Navbar view={view} navigate={navigate} />
        <main>
          {view === "admin" ? (
            <AdminPage />
          ) : view === "cancel" ? (
            <CancelPage token={cancelToken} />
          ) : view === "agenda" ? (
            <Booking
              onBack={() =>
                navigate(localStorage.getItem("si_admin_token") ? "?admin" : "/")
              }
            />
          ) : (
            <Hero onBook={() => navigate("?agendar")} />
          )}
        </main>
        <Footer />
      </div>
      <Toaster theme="dark" position="top-center" richColors />
    </div>
  );
}
